import StoredLayout from '../../layouts/StoredLayout'
import Badges from './Badges'
export default StoredLayout(Badges)



// WEBPACK FOOTER //
// ./src/ui-elements/badges/index.js